import React from 'react';
import CaseCardSkeleton from './CaseCardSkeleton';

interface CaseCardSkeletonGridProps {
  count?: number;
  columns?: string;
}

const CaseCardSkeletonGrid: React.FC<CaseCardSkeletonGridProps> = ({ 
  count = 9, 
  columns = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' 
}) => {
  return (
    <div className={`grid ${columns} gap-6`}>
      {Array.from({ length: count }).map((_, index) => (
        <CaseCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default CaseCardSkeletonGrid;
